module.exports = __webpack_public_path__ + "components/rewards/sixt/static/icon-6049b9b2758d5c94755142aaef8e1289.png";